import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface Branding {
  title: string;
  name: string;
  shortName: string | null;
  logoUrl: string;
}

const FALLBACK: Branding = { title: '', name: '', shortName: null, logoUrl: '/api/v1/branding/logo' };

/** Tên viết tắt & logo doanh nghiệp (Cài đặt → Thông tin doanh nghiệp); công khai nên dùng được cả ở trang đăng nhập. */
export function useBranding(): Branding {
  const qc = useQueryClient();
  const q = useQuery({
    queryKey: ['branding'],
    queryFn: () => api.get<Branding>('/branding'),
    staleTime: 5 * 60_000,
  });
  useEffect(() => {
    const refresh = () => void qc.invalidateQueries({ queryKey: ['branding'] });
    window.addEventListener('branding-changed', refresh);
    return () => window.removeEventListener('branding-changed', refresh);
  }, [qc]);
  return q.data ?? FALLBACK;
}
